export default {
	productIds: ['com.jdsoftwarellc.ginrummy.removeads'],
};
